import axios from "axios";

export const getTemplate = () => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/managelocations/getTemplate",
      {
        headers: {
          "Content-Type": "text/csv",
        },
        responseType: "blob",
      }
    )
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "locations.csv");
      document.body.appendChild(link);
      link.click();
      return true;
    })
    .catch((error) => {
      console.log(error);
      return false;
    });
};

export const uploadLocations = (file, careersClientId) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/managelocations/uploadlocations/" +
        encodeURIComponent(careersClientId),
      file,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((res) => res.data);
};

export const getLocations = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/managelocations/getlocations/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const getAddress = (addressId, careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/managelocations/getAddress/" +
        encodeURIComponent(addressId) +
        "/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const getCountries = () => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/managelocations/getcountries"
    )
    .then((res) => res.data);
};

export const getCoords = (address, city, division, zipcode) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/managelocations/getcoords/" +
        encodeURIComponent(city) +
        "/" +
        encodeURIComponent(division) +
        "/" +
        encodeURIComponent(zipcode) +
        "/" +
        encodeURIComponent(address) +
        "/"
    )
    .then((res) => res.data);
};

export const AddLocation = (model) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/managelocations/addlocation",
      model
    )
    .then((res) => res.data);
};

export const DeleteLocation = (locationId) => {
  return axios
    .delete(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/managelocations/deleteLocation/" +
        encodeURIComponent(locationId)
    )
    .then((res) => res);
};

export const editLocation = (model) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/managelocations/editlocation",
      model
    )
    .then((res) => res);
};
